<template>
  <div id="app">
    <!-- 官网页面单独处理，不使用布局 -->
    <router-view v-if="$route.name === 'OfficialWebsite'" />
    <!-- 其他页面使用默认布局 -->
    <router-view v-else />
  </div>
</template>

<script>
  export default {
    name: "AppRoot",
  };
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100vh;
  }
</style>